const { createContext } = require("react");

const KotharContext = createContext([{ state: [], actions: [] }]);
export default KotharContext;
